import { Link } from 'react-router-dom';
import { useAppConfig } from '@/api/useAppConfig';

/** Fallback when `Application:Branding:LogoPath` is not configured. */
const DEFAULT_LOGO = '/myui/img/Stellantis_logo_small.png';

/**
 * The header/sidebar logo (`_AppLogo.cshtml`).
 *
 * The Razor partial carried its own `<style>` block. Those rules now live in
 * `styles/shell.scss` so they are compiled once instead of being duplicated
 * into every page's HTML.
 */
export function AppLogo() {
  const { data: config } = useAppConfig();

  return (
    <div className="app-logo">
      <Link to="/" className="logo-link">
        <img
          src={config?.logoPath || DEFAULT_LOGO}
          alt={config?.code || 'Stellantis'}
          className="logo-svg"
        />
      </Link>
    </div>
  );
}
